<template>
    <div class="captail_wrap registrationSteps position-relative fullLoader p-0 w-100">
		<loader v-if="pageLoader && !regularCall"></loader>  
        <div class="middle_section m-0">
            <div class="top_searchbars">
                <div class="row">
                    <div class="col-12">
					   <div class="cap_logo_steps centerLogo p-3 d-flex justify-content-between align-items-center">
							<a href="#"><img src="../../../../static/website/images/logo.png" alt="Captail wallet"></a>
							<div class="rightBack d-flex align-items-center">
								<a href="#" class="backToDash" @click.prevent="logout()">Logout</a>
						    </div> 
						</div>
                    </div>
                </div>
            </div><!-- {{refreshDataApi}} -->
            <div class="midBox h-100 d-flex align-items-center justify-content-center" v-if="successTransfer"> <!-- v-if="successTransfer" -->
            	<div class="transactionSuccessful text-center">
            		<span class="imgSucess"><img src="../../../../static/website/images/successfulTran.svg" alt="Icon"> </span>
					<h3>Transaction Successful</h3>
					<span> your web page will redirect in <span style="color : red;">{{redirectIn}}</span> Seconds</span> 
				</div>
			</div>
			<div class="midBox h-100 d-flex align-items-center justify-content-center" v-else>
				<!-- <app-twofa :call_from="'twoFaAfterRegisteration'"  class="withdrawalAllow w-100 "></app-twofa> -->
				<div class="innerBlock">
					<div class="fxviewContent">
						<img src="../../../../static/website/images/fxview_logo.svg" alt="Logo" v-if="!generateWalletAddress">
						<div class="commentArea" v-if="marginData.optional_one">
							<p class="mb-0" v-if="generateWalletAddress">Deposit to this Address, We are Tracking your deposit...</p>
							<p class="mb-0" v-html="marginData.optional_one" v-else></p>
						</div>
					</div>
					<div class="formRedirect" v-if="marginData.amount">
						<alert-notification v-if="notification_msg != ''"/>
						<ul class="criptoList" v-if="!generateWalletAddress || marginData.deposit === false">
							<li>Currency : <span class="criptoIcon d-flex align-items-center">
								<img :src="'../../../../static/website/images/crypto_logos/'+ marginData.currency.toLowerCase()+'.png'" :alt="marginData.currency.charAt(0)"/>
	                            <span class="ml-2">{{marginData.currency}}</span>
	                            </span>
	                        </li>
							<li>Wallet Balance : <span></span>{{marginData.balance || 0}}</li>
							<li>Amount to be transferred : <span></span>{{marginData.amount}}</li>
						</ul>
						<div class="submitButtonAdd text-center my-4" v-if="'deposit' in marginData">
							<div v-if="marginData.deposit === false">
								<a href="#" class="cap_btn" @click="confirmTransaction()">Confirm</a>
							</div>
							<div class="Insufficient" v-if="marginData.deposit === true">
								<h6 class="red" v-if="!generateWalletAddress">Insufficient amount please deposit</h6>
								<a href="#" class="cap_btn" @click="getAddress()" v-if="!generateWalletAddress">Deposit</a>
								<div class="criptoOtherWallet" v-if="generateWalletAddress">
									<!-- <h6 class="">Deposit to this Address, We are Tracking your deposit...</h6> -->
									<div v-if="!['EOS','XLM'].includes(marginData.currency.toUpperCase())">
										<div class="mt-4 midContent section_title mb-0 text-center">
											<vue-qrcode :value="generateWalletAddress" />
											<div class="formLabel copyAddress text-left px-3 mt-4">
												<label class="mb-1">Wallet Address</label>
												<div class="midCopy position-relative overflow-hidden bg-white p-2">
													<div class="copied"  v-if="copy_msg1">
														<span>Copied</span>
													</div>
													<h4 class="addreGen">{{(generateWalletAddress)?generateWalletAddress:'-'}}</h4>
													<button class="copy"  :class="(generateWalletAddress)?'enabled':'disabled'" v-clipboard:copy="generateWalletAddress" v-clipboard:success="onCopy" v-clipboard:error="onError">
														<feather type="copy"></feather>
													</button>
												</div>
											</div>
										</div>
									</div>
									<div v-else>
										<div class="midContent section_title mb-0 text-center">
											<div class="formLabel copyAddress text-left px-3 mt-3">
												<label class="mb-1">Wallet Address</label>
												<div class="midCopy bg-white p-2 position-relative overflow-hidden">
													<div class="copied"  v-if="copy_msg1">
														<span>Copied</span>
													</div>
													<h4 class="addreGen">{{(generateWalletAddress)?generateWalletAddress.split("?")[0]:'-'}}</h4>
													<button class="copy"  :class="(generateWalletAddress)?'enabled':'disabled'" @click="copyText = '1'" v-clipboard:copy="(generateWalletAddress)?generateWalletAddress.split('?')[0]:'-'" v-clipboard:success="onCopy" v-clipboard:error="onError">
														<feather type="copy"></feather>
													</button>
												</div>
											</div>
										</div>
										<div class="midContent section_title mb-0 text-center">
											<div class="formLabel copyAddress text-left px-3 mt-3">
												<label class="mb-1">Memo ID</label>
												<div class="midCopy position-relative overflow-hidden bg-white p-2">
													<div class="copied"  v-if="copy_msg2">
														<span>Copied</span>
													</div>
													<h4 class="addreGen">{{getMemoId(generateWalletAddress) || '-'}}</h4>
													<button class="copy"  :class="(getMemoId(generateWalletAddress))?'enabled':'disabled'" @click="copyText = '2'" v-clipboard:copy="getMemoId(generateWalletAddress)" v-clipboard:success="onCopy" v-clipboard:error="onError">
														<feather type="copy"></feather>
													</button>
												</div>
											</div> 
										</div> 
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
        </div>
    </div>
</template>
<script>
	import VueQrcode from 'vue-qrcode'
	import * as types from '@/types'
	import { mapActions } from 'vuex'
	import { Const } from '@/plugins/depositWithdrawal/provider/lib/const.cls.ts'
	import tradingMixins from '@/plugins/trading';
	import { depositWithdrawalMixins } from '@/plugins/depositWithdrawal'
	export default {
		name: 'step-four',
		mixins: [depositWithdrawalMixins,tradingMixins],
		data() {
			return {
				submitted : false,
				pageLoader : true,
				marginData:{},
				notification_msg:'',
            	notification_type:'',
            	copy_msg1 : false,
				copy_msg2 : false,
				successTransfer: false,
				redirectIn: 5,
				regularCall: null
			}
		},
		components: {
			VueQrcode
		},
		watch:{
			refreshData(val){
				this.refreshDataApi()
			}
		},
		/*computed:{
			refreshDataApi(){
				if(parseInt(this.refreshData) == 1){
					this.$store.commit(Const.SET_GENERATE_WALLET_ADDRESS, '')
					this.getWalletMargin()
				}
			}
		},*/
		methods: {
			refreshDataApi(){
				if(parseInt(this.refreshData) == 1){
					this.$store.commit(Const.SET_GENERATE_WALLET_ADDRESS, '')
					this.getWalletMargin()
				}
			},
			...mapActions({
				_runLogout: types.RUN_LOGOUT
			}),
			confirmTransaction(){
				this._runConfirmWalletTransaction({ 'globalParams' :{}, 'localParams' :{ "parameter" : this } })
			},
			getMemoId(val){
				try{
					return val.split("?")[1].split("=")[1]
				}catch(e){ return null}
			},
			logout(){
				let input_json={
					'globalParams' :{},
					'localParams' :{ "parameter" : this }
				}
				this._runLogout(input_json)
			},
			afterGetMargin(){
				if(localStorage.getItem('prev_margin')){
					let margin = JSON.parse(window.atob(localStorage.getItem('prev_margin')))
					if(this.marginData.currency == margin.currency && this.marginData.amount == margin.amount ){
						if(this.marginData.balance || this.marginData.balance > margin.amount){
							this.$store.commit(Const.SET_GENERATE_WALLET_ADDRESS, '')
						}else if(!this.regularCall){
							this.getAddress()
						}
					}else{
						localStorage.removeItem('prev_margin')
					}
				}
			},
			regulerDetails(){
				try{
					let _that = this
					localStorage.setItem('prev_margin', window.btoa(JSON.stringify(this.marginData)));
					this.regularCall = setInterval(function(){
						if(_that.marginData.deposit === false){
							this.$store.commit(Const.SET_GENERATE_WALLET_ADDRESS, '')
							clearInterval(this.regularCall);
						}else{
							_that.getWalletMargin()
						}
					}, 30000);
				}catch(e){
					console.log('error----->',e)
				}
			},
			getAddress(){
				var account_id  = ''
				if(this.tradingAccount.length > 0  ){
					this.tradingAccount[0].subAccounts.forEach(value =>{
						if(this.marginData.currency.toLowerCase() == value.currency.toLowerCase()){
							account_id = value.act_account_id
						}
					})
				}//this.marginData.currency.toLowerCase()
				this._runGenerateWalletAddress({'globalParams' :{'currency' : this.marginData.currency.toLowerCase() , 'act_account_id' :account_id},'localParams' :{ "parameter" : this }})
			},
			onCopy(e) {
				if(this.copyText = '1'){
					this.copy_msg1 = true
				}else{
					this.copy_msg2 = true
				}
			    var _that = this
				setTimeout(()=>{ 
					_that.copy_msg1 = false
					_that.copy_msg2 = false
				}, 2000)
				
            },
            onError(e) {
			    var _that = this
				try{
			        _that.notification_msg = 'Address not Copied' ;
			        _that.notification_type = 'error' ;
			        setTimeout(function(){
			            _that.notification_msg = '' ;
			            _that.notification_type = '' ;
			        }, 5000);
			    }catch(e){}
            },
            getWalletMargin(){
            	this._rungetWalletMargin({ 'globalParams' :{}, 'localParams' :{ "parameter" : this } })
            }
		},
		created(){
			// this.$store.commit(Const.SET_GENERATE_WALLET_ADDRESS, '')
			// this.getWalletMargin()
			this.refreshDataApi()
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/website/user/crypto-deposit.vue